import { useState } from 'react';
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { getLastApplicationUpdate, setLastApplicationUpdate } from '../services/carpark.service';

export interface SimpleDialogProps {
    open: boolean;
    onClose: () => void;
}

const ApplicationUpdateDialog = (props: SimpleDialogProps) => {
    const { onClose, open } = props;
    const [scroll] = useState<DialogProps['scroll']>('paper');

    const handleClose = () => {
        onClose();
    };

    const handleUpdate = () => {
        setLastApplicationUpdate(new Date());
        window.location.reload();
    };

    const lastApplicationUpdate = getLastApplicationUpdate();

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle id="scroll-dialog-title">Last Application Update <Chip label={`${lastApplicationUpdate.toLocaleDateString()} ${lastApplicationUpdate.toLocaleTimeString()}`} /></DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
                >
                <Close />
            </IconButton>
            <DialogContent dividers={scroll === 'paper'}>
                <DialogContentText id="alert-dialog-description">
                    In order to get the latest features and improvements, please update the application.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleUpdate}>Update</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ApplicationUpdateDialog;